import { render, staticRenderFns } from "./SegmentAudio.vue?vue&type=template&id=6ece4959&scoped=true"
import script from "./SegmentAudio.vue?vue&type=script&lang=js"
export * from "./SegmentAudio.vue?vue&type=script&lang=js"
import style0 from "./SegmentAudio.vue?vue&type=style&index=0&id=6ece4959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece4959",
  null
  
)

export default component.exports